export default __webpack_public_path__ + "0b6999ca8a3233b0aa4b7341e64a3aac.png";